export function formatBalance(amount: number | undefined | null, options?: { minimumFractionDigits?: number; maximumFractionDigits?: number }): string {
  const value = amount ?? 0;
  return value.toLocaleString('en-IN', {
    minimumFractionDigits: options?.minimumFractionDigits ?? 2,
    maximumFractionDigits: options?.maximumFractionDigits ?? 2,
  });
}

export const TARIFF_UNITS: Record<string, string> = {
  Energy: '₹/kWh',
  Time: '₹/hr',
  Flat: '₹/session',
  ParkingTime: '₹/hr',
  default: '₹',
};
